import React, { useState } from 'react';
import { useReveal, JoinBlock, PageHeader } from '../components/shared';
import { DAHLIA_VARIETIES } from '../mock';

const Q = [
  {
    count: 'Question 1 of 3', q: 'How would you describe yourself?',
    opts: [
      { label: 'Just Getting Started', sub: 'new to this, a little cautious, very curious', w: 3, b: 1 },
      { label: 'A Few Years In', sub: "you know what you like, and you're leaning into it", w: 3, b: 2 },
      { label: 'Kicking Goals', sub: 'confident, a little ambitious, results to show for it', w: 3, b: 4 },
      { label: 'Absolutely Obsessed', sub: 'you already know exactly who you are', w: 3, b: 5 },
    ],
  },
  {
    count: 'Question 2 of 3', q: 'Tell us your colour palette.',
    opts: [
      { label: 'Bold', sub: 'saturated, loud, no apologies', w: 2, b: 5 },
      { label: 'Soft', sub: 'pastel, gentle, easy on the eye', w: 4, b: 1 },
      { label: 'Pink, Obviously', sub: 'is there really another option?', w: 3, b: 3 },
      { label: 'Not Fazed', sub: "honestly, whatever's blooming works for you", w: 5, b: 3 },
    ],
  },
  {
    count: 'Question 3 of 3', q: 'Last one — pick a Sunday.',
    opts: [
      { label: 'Slow breakfast, a book, no plans', w: 4, b: 1 },
      { label: 'A gallery, then a quiet dinner', w: 2, b: 2 },
      { label: 'Straight to the beach, salt in your hair', w: 5, b: 3 },
      { label: 'Somewhere loud, dancing by 9pm', w: 3, b: 5 },
    ],
  },
];

function petalSvg(petal, center) {
  return (
    <>
      <circle cx="20" cy="11" r="6.5" fill={petal} /><circle cx="28.6" cy="17.2" r="6.5" fill={petal} />
      <circle cx="25.3" cy="27.3" r="6.5" fill={petal} /><circle cx="14.7" cy="27.3" r="6.5" fill={petal} />
      <circle cx="11.4" cy="17.2" r="6.5" fill={petal} /><circle cx="20" cy="20" r="5.5" fill={center} />
    </>
  );
}

export default function Quiz() {
  useReveal([]);
  const [step, setStep] = useState(0);
  const [warmth, setWarmth] = useState([]);
  const [boldness, setBoldness] = useState([]);
  const [result, setResult] = useState(null);

  const answer = (opt) => {
    const w = [...warmth, opt.w];
    const b = [...boldness, opt.b];
    setWarmth(w); setBoldness(b);
    if (w.length < 3) { setStep(w.length); }
    else {
      const avgW = w.reduce((a, x) => a + x, 0) / w.length;
      const avgB = b.reduce((a, x) => a + x, 0) / b.length;
      const ranked = DAHLIA_VARIETIES.map((v) => ({ ...v, dist: Math.pow(v.w - avgW, 2) + Math.pow(v.b - avgB, 2) })).sort((a, c) => a.dist - c.dist);
      const top3 = ranked.slice(0, 3);
      const primary = top3[0];
      const reveal = primary.b >= 4 ? 'Ooh la la — let your dahlia obsession begin!' : primary.b <= 2 ? 'Sweet and quietly unforgettable — this is so you.' : "Well hello gorgeous — this one's got your name on it.";
      setResult({ primary, top3, reveal });
      setStep(3);
    }
  };
  const restart = () => { setStep(0); setWarmth([]); setBoldness([]); setResult(null); };
  const progress = result ? 100 : step * 33;

  return (
    <div className="page active">
      <PageHeader eyebrow="60 Seconds · No Email Required" title="What's Your Dahlia Personality?" sub="Answer three questions, meet your bloom." />

      <div className="quiz-wrap">
        {!result && Q.map((qq, i) => (
          <div className={`quiz-step${step === i ? ' active' : ''}`} key={i}>
            <span className="quiz-count">{qq.count}</span>
            <h2 className="quiz-q">{qq.q}</h2>
            <div className="quiz-opts">
              {qq.opts.map((o, j) => (
                <button className="quiz-opt" key={j} onClick={() => answer(o)}>
                  <span className="quiz-opt-label">{o.label}</span>
                  {o.sub && <span className="quiz-opt-sub">{o.sub}</span>}
                </button>
              ))}
            </div>
          </div>
        ))}

        {result && (
          <div className="quiz-step active">
            <div className="quiz-result">
              <p className="quiz-reveal-line">{result.reveal}</p>
              <svg className="quiz-result-icon" width="60" height="60" viewBox="0 0 40 40">{petalSvg(result.primary.petal, result.primary.center)}</svg>
              <span className="eyebrow rev in" style={{ textAlign: 'center', display: 'block' }}>{result.primary.tone} — Your Dahlia Personality Is</span>
              <h2 className="quiz-result-title">{result.primary.name}.</h2>
              <p className="quiz-result-body">{result.primary.body}</p>
              <div className="quiz-top3">
                <span className="quiz-top3-label">Your Top 3 Dahlias Are</span>
                <div className="quiz-top3-list">
                  {result.top3.map((v, i) => (<span className={`quiz-top3-item${i === 0 ? ' primary' : ''}`} key={i}>{v.name}</span>))}
                </div>
              </div>
              <div className="quiz-restart" onClick={restart}>↺ Take it again</div>
            </div>
          </div>
        )}

        <div className="quiz-progress"><div className="quiz-progress-bar" style={{ width: `${progress}%` }} /></div>
      </div>

      <JoinBlock eyebrow="Get Your Result By Email Too" headline="Join our community.<br>First dibs on everything." body="Farm gate updates, wholesale availability, pick-your-own dates, dahlia tuber first access and growing tips — all to our community, before anyone else." />
    </div>
  );
}
